/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BuilderNavigationService,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, UserContext } from '@gh/common-shared';

import { DialogService, NotificationService, WaitingService } from '@gh/core-ui';
import {
  OfficeRolePermissionNode,
  OfficeRolePermissionTree,
} from '../../resources/office-role-permission-tree.model';
import { OfficeRolePermissionsBusinessService } from '../../resources/office-role-permissions-business.service';

import { AbstractOfficeRolePermissionsTabComponent } from './abstract-office-role-permissions-tab.component';

@Component({
  standalone: false,
  selector: 'gh-office-role-permissions-setup-tab',
  templateUrl: 'office-role-permissions-application-tab.component.html',
})
export class OfficeRolePermissionsSetupTabComponent extends AbstractOfficeRolePermissionsTabComponent {

  constructor(protected route: ActivatedRoute,
              private navigationService: BuilderNavigationService,
              protected userContext: UserContext,
              protected notificationService: NotificationService,
              protected dialogService: DialogService,
              protected waitingService: WaitingService,
              private officeRoleBusiness: OfficeRolePermissionsBusinessService,
              private pipelines: FormActionPipelines,
              private commonActions: CommonActions) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<OfficeRolePermissionTree>> {
    return this.pipelines.complete({
      execute: this.commonActions.execute(({ value }) =>
        this.officeRoleBusiness.updateSetupPermissions(this.normalizeTree(value))),
      finish: ({ value }) => this.refresh(value),
    });
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.form.value.roleId,
      entityType: 'OFFICE_ROLE',
      eventTypeIds: [AelEvents.OfficeRolePermissions.EditedSetup],
      label: 'lbl_office_roles_setup_permissions',
    });
  }

  protected treeToDisplayedNodes(tree: OfficeRolePermissionTree): OfficeRolePermissionNode[] {
    const root = tree.roots[0];

    return root.children || [];
  }

  private normalizeTree(tree: OfficeRolePermissionTree): OfficeRolePermissionTree {
    const setupRoot = tree.roots[0];
    const children = setupRoot.children || [];

    setupRoot.allowed = children.some((child) => child.allowed);

    return tree;
  }
}
